import Papa from "papaparse";
export function readCsv(content) {
    return Papa.parse(content, {
        skipEmptyLines: true,
    }).data.filter((row) => {
        const values = new Set(row);
        return !(values.size === 1 && values.has(""));
    });
}
//# sourceMappingURL=read-csv.mjs.map